export const cardStyle = {
	cardPosition: {
		margin: '100px auto',
		width: '400px'
	},
	cardHeader: {
		background: '#db621c',
		fontWeight: 'bold',

	}

};
export const errorStyle = {

	width: '100%',
	padding: '5px',
	background: '#F44336',
	textAlign: 'center',
	display: 'inline-block',

};

export const loadingStyle ={
	width: '100%',
	padding: '5px',
	background: '#1B5E20',
	textAlign: 'center',
	color:'white',
	display: 'inline-block',
};